<template>

  <!-- eslint-disable  -->
  <div class="m-2 lg:m-8">

    <h1 class="text-gray-800 text-4xl text-left mb-4"> Kontakt </h1>

    <div v-if="this.$store.state.fetchVorstandComplete == true && this.$store.state.vorstand.length > 0" class="flex flex-wrap mb-16 max-w-screen-lg">

      <div class="card pb-4 px-1 sm:px-1 lg:px-2 flex flex-wrap w-1/2 sm:w-1/3 md:w-1/4 lg:w-1/5" v-for="index in sortVorstand">

      <div class="rounded-lg bg-blue-100 text-left w-full sm:m-0 p-2 sm:p-0">

        <div v-if="index.bild" class="h-42 md:h-32 mb-2 w-full mx-auto bg-blue-100 mt-4">

          <img class="rounded-none object-cover w-3/4 md:w-1/2 mx-auto" :src="index.bild.url" alt="">

        </div>

        <div v-else class="h-42 md:h-32 mb-2 w-full mx-auto bg-blue-100 mt-4">

          <img class="rounded-none object-cover w-2/3 md:w-1/2 mx-auto" src="https://weissenburgbad.ch/wordpress/wp-content/uploads/2021/01/user_placeholder.png" alt="">

        </div>

        <!-- Bild Ende -->

        <div class="p-3">

          <div class="kontaktfeld" v-html="index.beschreibung"> </div>

        </div>
      </div>

    </div>

  </div>

  <div class="" v-else>

    <p>Kontakte können nicht angezeigt werden. Versuchen Sie, die Seite neu zu laden.</p>
    <p>Falls das Problem weiterhin besteht, wurden wahrscheinlich keine Kontakte in Wordpress erfasst.</p>
    <p>Erfassen Sie diese unter Wordpress -> Vorstand</p>

  </div>

  <!-- <div class="mx-8 w-1/4 mx-auto">

  <img :src="$store.state.kontakt.bild.url" alt="">

</div> -->

</div>
</template>

<script>

export default {
  components: {

  },
  name: 'Kontakt',
  props: {

  },
  data() {
    return {

      actualYear: '',
      actualDate: '',

    }
  },
  methods: {

    convert(old){

      // console.log("nodedate:" + old);

      var monthNames = ["Januar", "Februar", "März", "April", "Mai", "Juni",
      "Juli", "August", "September", "Oktober", "November", "Dezember"];

      // console.log(old)

      var yyyy = old.slice(0, 4)
      // console.log("Actual:" + yyyy);
      // console.log("This:" + this.actualYear)

      var mm = old.slice(4, 6)
      mm = parseInt(mm)

      var dd = old.slice(6, 8)

      if (yyyy == this.actualYear){
        return (dd + ". " + monthNames[mm-1] + " " + yyyy);
      } else {
        return (dd + ". " + monthNames[mm-1] + " " + yyyy);
      }
    },

    getdate(){
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0');
      var yyyy = today.getFullYear();

      // console.log(today = dd + '. ' + monthNames[mm] + ' ' + yyyy);

      this.actualYear = yyyy;
      this.actualDate = yyyy + mm + dd

      // console.log("DATUM IST" + this.actualDate);
    },

    compare(a, b) {
      if (a.sortieren < b.sortieren) {
        return -1;
      }
      if (a.sortieren > b.sortieren) {
        return 1;
      }
      // a muss gleich b sein
      return 0;
    },

  },
  mounted: function(){

    this.getdate();

  },

  computed: {

    sortVorstand() {
      // console.log(this.$store.state.vorstand.slice().sort(this.compare));
      return this.$store.state.vorstand.slice().sort(this.compare);
    },

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
